/** Column names that mark a CSV's scan-id column (and its header row). */
const SCAN_ID_HEADERS = ['scan_id', 'scanid', 'scan id', 'id', 'inspection_id', 'inspectionid'];

const isValidScanId = (id: string) =>
  /^[a-zA-Z0-9-_.]+$/.test(id) && id.length > 5 && !SCAN_ID_HEADERS.includes(id.toLowerCase());

/**
 * Parse scan ids out of a CSV. Accepts one id per line or a full export with a
 * header row, in which case the `scan_id`-ish column is used; otherwise the
 * first column. Mirrors the lightning batch upload so the same file works in
 * both places.
 */
export function parseScanCsv(text: string): string[] {
  const lines = text.split(/[\r\n]+/).filter((line) => line.trim());
  if (lines.length === 0) return [];

  const splitRow = (line: string) => line.split(',').map((part) => part.trim());
  const header = splitRow(lines[0]).map((h) => h.toLowerCase());
  let scanCol = header.findIndex((h) => SCAN_ID_HEADERS.includes(h));
  const hasHeader = scanCol >= 0;
  if (scanCol < 0) scanCol = 0;

  const ids: string[] = [];
  for (const line of hasHeader ? lines.slice(1) : lines) {
    const id = splitRow(line)[scanCol];
    if (id && isValidScanId(id)) ids.push(id);
  }
  return ids;
}
